<template>
  <v-scale-transition origin="center">
    <v-btn
      v-show="scrollPosition > 400"
      id="scroll-top"
      class="pa-0"
      color="black"
      fixed
      @click="scrollTop"
    >
      <v-icon color="white">mdi-chevron-up</v-icon>
    </v-btn>
  </v-scale-transition>
</template>

<script>
export default {
  data() {
    return {
      scrollPosition: window.scrollY
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
    }
  }
};
</script>

<style scoped>
#scroll-top {
  z-index: 4;
  bottom: 20px;
  right: 20px;
  height: 30px !important;
  min-width: 30px !important;
  cursor: pointer;
}
#scroll-top:hover {
  background-color: #00a9ce !important;
}
</style>
